import { CommonModule, CurrencyPipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbModal, NgbNavModule, NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { LaddaModule } from "angular2-ladda";
import * as moment from "moment";
import { AvatarModule } from "ngx-avatars";
import { ToastrService } from "ngx-toastr";
import { SharedModule } from "primeng/api";
import { CalendarModule } from "primeng/calendar";
import { DialogModule } from "primeng/dialog";
import { TooltipModule } from "primeng/tooltip";
import { DisplayDescriptionComponent } from "src/app/shared/components/display-description/display-description.component";
import {
  API_URLS,
  AVATAR_BG_COLOR,
  AVATAR_FG_COLOR,
  DATEFORMATE,
  PRODUCT_PATH,
  P_CALENDAR_DATE_FORMAT,
  SCROLLBARS_OPTIONS,
} from "../../../../config/app.constants";
import { CartsService } from "../../../../shared/services/carts.service";
import { HttpinterceptorService } from "../../../../shared/services/httpinterceptor.service";
import { Utils } from "../../../../shared/utils";
import { PreviousGroomerListComponent } from "../../grooming/previous-groomer-list/previous-groomer-list.component";
import { StarRatingComponent } from "../../star-rating/star-rating.component";

declare var $: any;

@Component({
  selector: "app-grooming-plan-modal",
  templateUrl: "./grooming-plan-modal.component.html",
  styleUrls: ["./grooming-plan-modal.component.scss"],
  providers: [CurrencyPipe],
  standalone: true,
  imports: [
    NgSelectModule,
    FormsModule,
    StarRatingComponent,
    CalendarModule,
    SharedModule,
    NgbTooltip,
    AvatarModule,
    LaddaModule,
    DialogModule,
    CurrencyPipe,
    CommonModule,
    NgbNavModule,
    TooltipModule,
  ],
})
export class GroomingPlanModalComponent implements OnInit {
  @Input() set petDetails(val) {
    if (localStorage.getItem("selectedOutpostId")) {
      this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
    }
    if (val) {
      this.petDetail = val;
      this.getPets();
    }
  }

  @Input() set planDetails(val) {
    if (val) {
      this.planDetail = val;
      this.getGroomingPlanList();
    }
  }

  @Input() set showGroomingPlanModal(val) {
    if (val) {
      this.resetData();
      this.openModal();
    }
  }

  @Input() set isChangeClinic(val) {
    if (val) {
      this.active = "tab5";
      this.updateTabCompletionStatus(5);
      this.activeTabs = ["products", "payment"];
    } else {
      this.active = "tab1";
      this.updateTabCompletionStatus(1);
      this.activeTabs = [
        "plan",
        "addons",
        "date",
        "groomers",
        "products",
        "payment",
      ];
    }
  }

  @Output() closeGroomingPlanModal = new EventEmitter<boolean>();

  petDetail: any;
  planDetail: any;
  userPets: any;

  selectedPetId: any;
  selectedPet: any;
  selectedPetSpecies: string = "";
  selectedPetSize: string = "";
  groomingPetName: string = "";
  petSizeList: any = [];

  validatePetSize: boolean = false;
  descriptionValue: any;
  is_advance_booking_amount: boolean = true;
  isPetPreviouslyGroomed: boolean = false;
  isGroomerPreviouslySelected: boolean = false;
  cartProcess: boolean = false;
  paymentSummary: boolean = false;
  minimumPaymentFlag: boolean = false;
  maximumPaymentFlag: boolean = false;

  groomingDate: Date;
  minDate: Date;
  maxDate: Date;

  selectedDateArray = [];
  groomingAddonList = [];
  selectedServices = [];
  selectedAddonList = [];
  groomerList = [];

  selectedGroomingPlan: any;
  selectedGroomer: any;
  groomingPlanList: any;
  priceCalculationFromApi: any;
  updatedAmount: any;
  selectedOutpostId;

  previousGroomer: any;
  isPreviousGroomerContinue: boolean = false;
  previousGroomerSelectedDate: Date;
  previousGroomerAvailableDates: any;

  format = DATEFORMATE;
  pCalendarDateFormat: string = P_CALENDAR_DATE_FORMAT;
  imagePath = API_URLS.FILE_PATH_USER_PROFILE;
  scrollbarOptions = SCROLLBARS_OPTIONS;

  avatar_fg_color = AVATAR_FG_COLOR;
  avatar_bg_color = AVATAR_BG_COLOR;

  cartDetailsToSend = {
    grooming_plan_id: "",
    grooming_addon_ids: "any",
    groomer_id: "",
    bather_id: "",
    pet_info: {},
    item_type: "",
    is_renewable: false,
  };

  mandatoryProductList = [];
  isMandatoryProducts: boolean = false;
  selectedProduct = [];
  iscontinueDisabled: boolean = false;
  productImagePath = PRODUCT_PATH;
  cartDetails;
  stateHidden;
  // isShowStep = false;

  holidayDateList: any = [];
  active: string = "tab1";
  isRightMarkForFirst: boolean = false;
  isRightMarkForSecond: boolean = false;
  isRightMarkForThird: boolean = false;
  isRightMarkForForth: boolean = false;
  isRightMarkForFifth: boolean = false;
  isRightMarkForSixth: boolean = false;
  activeTabs: string[] = [
    "plan",
    "addons",
    "date",
    "groomers",
    "products",
    "payment",
  ];

  constructor(
    private http: HttpinterceptorService,
    private toasterService: ToastrService,
    private cartsService: CartsService,
    private cp: CurrencyPipe,
    private modalService: NgbModal
  ) {
    this.cartDetails = JSON.parse(this.cartsService.getCartItems());

    // Get Product from Cart APi

    this.cartDetails.items.forEach((cart) => {
      if (
        cart.mandatory_product_detail &&
        cart.mandatory_product_detail.length
      ) {
        this.selectedProduct = cart.mandatory_product_detail.map(
          (product) => product.id
        );
      }
    });

    let today = new Date();
    today.setDate(today.getDate() + 25);
    this.maxDate = today;
  }

  ngOnInit(): void {
    this.getPets();

    if (localStorage.getItem("selectedOutpostId")) {
      this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
    }
  }

  getCurrentIndex(activeTab?, event?) {
    if (event) {
      return parseInt(event.nextId.substr(3));
    } else if (activeTab) {
      return parseInt(this.active.substring(3));
    }
  }

  // get user pets
  getPets() {
    this.http
      .post(API_URLS.GET_USER_PETS, { has_grooming: true }, false)
      .subscribe((response) => {
        const pets = [];
        if (response.type === "success" && response.data) {
          response.data = response.data.filter((pet) => pet?.is_active);

          for (const index in response.data) {
            if (response.data.hasOwnProperty(index)) {
              pets.push(response.data[index]);
            }
          }
        }
        this.userPets = pets;
        if (this.petDetail) {
          this.selectedPetId = this.petDetail.id;
          this.changePetSelection();
        }
      });
  }

  // select pet from pet list
  changePetSelection() {
    this.selectedPet =
      this.userPets[
        this.userPets
          .map((pet) => {
            return pet.id;
          })
          .indexOf(this.selectedPetId)
      ];
    this.groomingPetName = this.selectedPet.name;
    this.selectedPetSpecies = this.selectedPet.pet_type_id;
    this.selectedPetSize = this.planDetail.planEditMode
      ? this.petDetail.pet_size_id
      : this.selectedPet.pet_size_id;
    this.getPetSizeList();
    this.getProductList();
    this.getHolidayDateList();
  }

  changePetSizeSelection() {
    this.getGroomingPlanList();
  }

  // get pet size from API
  getPetSizeList() {
    this.http
      .post(
        API_URLS.GET_PET_SIZE,
        { pet_type_id: this.selectedPetSpecies },
        false
      )
      .subscribe(
        (response) => {
          let newSize = [];
          if (response.data) {
            for (const index in response.data) {
              if (Object.prototype.hasOwnProperty.call(response.data, index)) {
                newSize.push({ id: index, title: response.data[index] });
              }
            }
          }
          this.petSizeList = newSize;
          if (this.petSizeList.length) {
            if (this.selectedPet.pet_size_id != "") {
              this.selectedPetSize = this.planDetail.planEditMode
                ? this.petDetail.pet_size_id
                : this.selectedPet.pet_size_id;
            }
          } else {
            this.selectedPetSize = null;
          }
          this.getGroomingPlanList();
        },
        (error) => {
          this.petSizeList = [];
        }
      );
  }

  // get list of grooming plan from API
  getGroomingPlanList() {
    this.http
      .post(
        API_URLS.GET_GROOMING_PLAN_LIST,
        {
          pet_type_id: this.selectedPetSpecies,
          pet_size_id: this.selectedPetSize,
          pet_id: this.selectedPet,
          out_post_id: this.selectedOutpostId,
        },
        false
      )
      .subscribe((response) => {
        if (response.data) {
          for (const index in response.data) {
            if (response.data.hasOwnProperty(index)) {
              // response.data[index]['descriptionParsed'] = Utils.htmlToPlaintext(response.data[index].description);
              response.data[index]["HTMLDescription"] =
                response.data[index].description;
              response.data[index]["description"] = Utils.htmlToPlaintext(
                response.data[index].description
              );
            }
          }
          this.groomingPlanList = response.data;
        }
        if (this.planDetail) {
          const plan = this.groomingPlanList.filter(
            (data) => data.id == this.planDetail.id
          );
          if (plan && plan[0]) {
            this.selectGroomingPlan(plan[0]);
          }
        }
      });
  }

  // select particular grooming plan from list
  selectGroomingPlan(plan) {
    this.selectedGroomingPlan = plan;
    this.groomingDate = null;
    this.selectedDateArray = [];
    this.selectedGroomer = null;
    this.selectedAddonList = [];
    this.selectedServices = [];
    this.priceCalculationFromApi = null;
    this.getGroomingAddonList();
  }

  // get list of grooming addon
  getGroomingAddonList() {
    this.groomingAddonList = [];
    if (this.selectedGroomingPlan.addons) {
      for (const iterator in this.selectedGroomingPlan.addons) {
        if (this.selectedGroomingPlan.addons.hasOwnProperty(iterator)) {
          this.groomingAddonList.push(
            this.selectedGroomingPlan.addons[iterator]
          );
        }
      }
      if (this.planDetail.planEditMode) {
        this.selectAddonsForEdit();
        this.groomingDate = new Date(this.planDetail.groomingDate);
        this.selectGroomingDate();
        this.is_advance_booking_amount =
          this.planDetail.is_advance_grooming_amount;
        this.updatedAmount = this.planDetail.advance_payment;
      }
    }
  }

  // select unselect addon
  selectServices(addon) {
    if (addon && this.selectedServices.indexOf(addon.id) == -1) {
      this.selectedServices.push(addon.id);
      this.selectedAddonList.push(addon);
    } else {
      for (const key in this.selectedServices) {
        if (this.selectedServices.hasOwnProperty(key)) {
          if (this.selectedServices[key] == addon.id) {
            this.selectedServices.splice(parseInt(key), 1);
            this.selectedAddonList.splice(parseInt(key), 1);
          }
        }
      }
    }
  }

  // set addon selected at the time of edit plan
  selectAddonsForEdit() {
    if (this.planDetail.extraServices) {
      for (const index in this.planDetail.extraServices) {
        if (
          Object.prototype.hasOwnProperty.call(
            this.planDetail.extraServices,
            index
          )
        ) {
          this.selectServices(
            this.groomingAddonList[
              this.groomingAddonList.findIndex(
                (addon) => addon.id == this.planDetail.extraServices[index].id
              )
            ]
          );
        }
      }
    }
  }

  // select date of grooming
  selectGroomingDate() {
    if (this.groomingDate) {
      this.checkAlreadyHaveGroomingOnDate();
    }
  }
  checkAlreadyHaveGroomingOnDate() {
    const dateOfGrooming = Utils.getDateFormat(this.groomingDate);
    const groomingDate =
      dateOfGrooming[2] + "-" + dateOfGrooming[1] + "-" + dateOfGrooming[0];
    this.http
      .post(
        API_URLS.GET_GROOMING_AVAIBILITY_LIST,
        {
          pet_id: this.selectedPetId,
          schedule_date: groomingDate,
        },
        false
      )
      .subscribe({
        next: (res) => {
          if (res?.type == "error" && res.is_duplicate) {
            this.toasterService.error(res.message);
            this.activeTabs = ["groomers", "products", "payment"];
            this.groomingDate = null;
          } else {
            this.selectedGroomer = null;
            this.selectedDateArray = [];
            const date = Utils.getDateFormat(this.groomingDate);
            this.selectedDateArray.push(
              date[0] + "/" + date[1] + "/" + date[2]
            );
            this.getGroomerList();
          }
        },
      });
  }

  getSelectedDays(date) {
    if (this.groomingDate) {
      const format = date.day + "/" + (date.month + 1) + "/" + date.year;
      return this.selectedDateArray.includes(format);
    }
  }

  // get list of groomer from API
  getGroomerList() {
    this.isGroomerPreviouslySelected = false;
    if (this.groomingDate) {
      const dateOfGrooming = Utils.getDateFormat(this.groomingDate);
      const grooming_date =
        dateOfGrooming[2] + "-" + dateOfGrooming[1] + "-" + dateOfGrooming[0];
      this.http
        .post(
          API_URLS.GET_GROOMER_LIST,
          {
            grooming_plan_id: this.selectedGroomingPlan.id,
            pet_size_id: this.selectedPetSize,
            schedule_date: grooming_date,
            pet_id: this.selectedPetId,
            out_post_id: this.selectedOutpostId,
          },
          false
        )
        .subscribe((response) => {
          if (response.data) {
            this.groomerList = response.data.groomer_list;
            this.isPetPreviouslyGroomed = response.data.previously_groomed;

            for (const index in this.groomerList) {
              if (this.groomerList.hasOwnProperty(index)) {
                if (this.groomerList[index].is_previous_groomer) {
                  this.isGroomerPreviouslySelected = true;
                }
                if (this.groomerList[index].working_days) {
                  this.groomerList[index].working_days =
                    this.groomerList[index].working_days.split(",");
                  for (const key in this.groomerList[index].working_days) {
                    if (
                      this.groomerList[index].working_days.hasOwnProperty(key)
                    ) {
                      this.groomerList[index].working_days[key] =
                        this.groomerList[index].working_days[key].slice(0, 3);
                    }
                  }
                }
              }
            }
            if (this.planDetail.planEditMode) {
              this.selectGroomer(
                this.groomerList[
                  this.groomerList.findIndex(
                    (groomer) => groomer.id == this.planDetail.groomer.id
                  )
                ]
              );
            }
          }
          if (
            this.previousGroomer &&
            this.previousGroomer.groomer.id &&
            this.previousGroomerSelectedDate
          ) {
            this.groomerList.map((groomer) => {
              if (groomer.id == this.previousGroomer.groomer.id) {
                this.selectGroomer(groomer);
              }
            });
          }
        });
    }
  }

  onClickPreviousGroomer() {
    this.getPreviousGroomerDetails();
  }

  // get the list of previously selected groomer from API
  getPreviousGroomerDetails() {
    /* const dateOfGrooming = Utils.getDateFormat(this.groomingDate);
    const groomingDate =
      dateOfGrooming[2] + "-" + dateOfGrooming[1] + "-" + dateOfGrooming[0]; */
    this.http
      .post(
        API_URLS.GET_PREVIOUS_GROOMER_DETAILS,
        {
          schedule_date: moment().add(1, "days").format("YYYY-MM-DD"),
          pet_id: this.selectedPetId,
          type: "regular",
          selected_styles: this.selectedGroomingPlan.id,
          grooming_plan_id: this.selectedGroomingPlan.id,
          pet_size_id: this.selectedPetSize,
          out_post_id: this.selectedOutpostId,
        },
        false
      )
      .subscribe((response) => {
        if (response.type === "success" && response.code === 200) {
          if (response.data) {
            this.previousGroomer = response.data;
            this.previousGroomerAvailableDates = response.data.dates;
            if (this.previousGroomer.groomer.working_days) {
              this.previousGroomer.groomer.working_days =
                this.previousGroomer.groomer.working_days.split(",");
              for (const key in this.previousGroomer.groomer.working_days) {
                if (
                  this.previousGroomer.groomer.working_days.hasOwnProperty(key)
                ) {
                  this.previousGroomer.groomer.working_days[key] =
                    this.previousGroomer.groomer.working_days[key].slice(0, 3);
                }
              }
            }
            this.openPreviousGroomerModal();
          }
        }
      });
  }

  // on selection of previous groomer date
  onPreviousGroomerDateSelect(date) {
    this.previousGroomerSelectedDate = date;
  }

  // after select of previous groomer
  OnPreviousGroomerContinue() {
    if (this.previousGroomerSelectedDate) {
      this.groomingDate = new Date(this.previousGroomerSelectedDate);
      this.selectGroomingDate();
    }
  }

  // on select groomer
  selectGroomer(groomer) {
    if (this.selectedGroomer == groomer) {
      this.selectedGroomer = null;
    } else {
      this.selectedGroomer = groomer;
    }
  }

  // get calculation of grooming prices from API
  getGroomingCalculation() {
    const dateOfGrooming = Utils.getDateFormat(this.groomingDate);
    const groomingDate =
      dateOfGrooming[2] + "-" + dateOfGrooming[1] + "-" + dateOfGrooming[0];
    let addonList = "";
    if (this.selectedServices.length > 0) {
      addonList = this.selectedServices.join(",");
    }
    this.paymentSummary = true;
    this.http
      .post(
        API_URLS.GET_GROOMING_PRICE_CALCULATION,
        {
          pet_type_id: this.selectedPet.pet_type_id,
          pet_size_id: this.selectedPetSize,
          grooming_plan_id: this.selectedGroomingPlan.id,
          schedule_date: groomingDate,
          groomer_id:
            this.selectedGroomer && this.selectedGroomer.id
              ? this.selectedGroomer.id
              : "",
          grooming_addon_ids: addonList,
          pet_id: this.selectedPetId,
          out_post_id: this.selectedOutpostId,
          product_ids: this.selectedProduct.toString(),
        },
        false
      )
      .subscribe(
        (response) => {
          this.paymentSummary = false;
          if (
            response.code === 200 &&
            response.type === "success" &&
            response.data
          ) {
            this.priceCalculationFromApi = response.data;
            this.updatedAmount =
              this.planDetail.planEditMode &&
              this.planDetail.advance_payment <=
                this.priceCalculationFromApi.payable_amount
                ? this.planDetail.advance_payment
                : this.priceCalculationFromApi.payable_amount;
          } else {
            this.paymentSummary = false;
            return false;
          }
        },
        (error) => {
          this.paymentSummary = false;
          return false;
        }
      );
  }

  // grooming plan add to cart
  addToCartPlan() {
    const dateOfGrooming = Utils.getDateFormat(this.groomingDate);
    const groomingDate =
      dateOfGrooming[2] + "-" + dateOfGrooming[1] + "-" + dateOfGrooming[0];
    this.cartDetailsToSend.item_type = "grooming";
    this.cartDetailsToSend.grooming_plan_id = this.selectedGroomingPlan.id;
    if (this.selectedServices.length > 0) {
      this.cartDetailsToSend.grooming_addon_ids =
        this.selectedServices.toString();
    } else {
      this.cartDetailsToSend.grooming_addon_ids = "";
    }
    this.cartDetailsToSend.groomer_id = this.selectedGroomer
      ? this.selectedGroomer.id
      : "";
    this.cartDetailsToSend["pet_id"] = this.selectedPetId;
    this.cartDetailsToSend["pet_type_id"] = this.selectedPet.pet_type_id;
    this.cartDetailsToSend["pet_size_id"] = this.selectedPetSize;
    this.cartDetailsToSend["advance_payment"] = this.is_advance_booking_amount
      ? this.updatedAmount
      : 0;
    this.cartDetailsToSend["is_advance_grooming_amount"] =
      this.is_advance_booking_amount;
    this.cartDetailsToSend["schedule_date"] = groomingDate;
    this.cartDetailsToSend["out_post_id"] = this.selectedOutpostId;
    this.cartDetailsToSend["product_ids"] = this.selectedProduct.toString();

    if (this.planDetail.planEditMode) {
      this.cartDetailsToSend["cart_id"] = this.planDetail.cart_id;
    }
    this.cartDetailsToSend.pet_info = {
      age: this.petDetail.age,
      breed: this.petDetail.breed,
      color: this.petDetail.color,
      description: this.petDetail.description,
      microchip: this.petDetail.microchip,
      name: this.petDetail.name,
      pet_id: this.selectedPetId,
      pet_type_id: this.selectedPet.pet_type_id,
      sex: this.petDetail.sex,
      weight: this.petDetail.weight,
    };
    this.cartProcess = true;
    this.http
      .post(API_URLS.UPDATE_CART, this.cartDetailsToSend, true)
      .subscribe(
        (res) => {
          this.cartProcess = false;
          if (res.type === "success" && res.code === 200) {
            if (res.data) {
              this.resetData();
              this.closeModal(true);
            }
          }
        },
        (error) => {
          this.cartProcess = false;
          return false;
        }
      );
  }

  // calculate minimum and maximum payable amount with validation
  calculateMinimumAmount(minimumAmount) {
    if (parseFloat(minimumAmount) == 0) {
      this.minimumPaymentFlag = true;
      this.maximumPaymentFlag = false;
      return false;
    } else if (
      parseFloat(minimumAmount) > 0 &&
      minimumAmount <= this.priceCalculationFromApi.payable_amount
    ) {
      this.maximumPaymentFlag = false;
      this.minimumPaymentFlag = false;
      return false;
    } else if (parseFloat(minimumAmount) < 0) {
      this.minimumPaymentFlag = true;
      this.maximumPaymentFlag = false;
    } else {
      this.maximumPaymentFlag = true;
      this.minimumPaymentFlag = false;
      return false;
    }
  }

  // reset all modal data
  resetData() {
    this.groomingDate = null;
    this.selectedDateArray = [];
    this.selectedGroomer = null;
    this.selectedAddonList = [];
    this.selectedServices = [];
    this.selectedGroomingPlan = null;
    this.groomerList = [];
    this.priceCalculationFromApi = null;
    this.updatedAmount = 0;
    this.cartsService.getCartWithApi();
  }

  // open modal for show description in detail
  showDescription(title, description) {
    const params = { title: title, description: description };
    const modalRef = this.modalService.open(DisplayDescriptionComponent, {
      size: "xl",
      centered: true,
      backdrop: "static",
      keyboard: false,
    });

    modalRef.componentInstance.fromParent = { data: params };
  }

  openModal() {
    $("#groomingPlanModal").modal("show");
    this.minDate = new Date();

    this.minDate.setDate(this.minDate.getDate() + 1); // Tomorrow Date
    this.minDate.setHours(0, 0, 0, 0); // Set time to start of the day
  }

  closeModal(flag?) {
    $("#groomingPlanModal").modal("hide");
    Utils.enableBodyScroll();
    this.closeGroomingPlanModal.emit(flag ? true : false);
    this.resetNavTab();
  }

  toastMessage(type, message) {
    this.toasterService[type](message);
  }
  // Get Mandatory product list
  getProductList() {
    // this.isShowStep = false;
    this.http
      .post(
        API_URLS.MANDATORY_PRODUCTS_LIST,
        {
          pet_ids: [this.petDetail.id],
          pet_type_id: this.petDetail.pet_type_id
            ? this.petDetail.pet_type_id
            : this.selectedPetSpecies,
        },
        false
      )
      .subscribe(
        (response) => {
          if (
            response.code === 200 &&
            response.type === "success" &&
            response.data
          ) {
            for (const data in response.data) {
              if (Object.prototype.hasOwnProperty.call(response.data, data)) {
                response.data[data]["mandatory_products"] = response.data[
                  data
                ].mandatory_products.filter(
                  (product) => product.status_to_given
                );
              }
            }
            for (const data in response.data) {
              this.selectedProduct = [];
              if (response.data.hasOwnProperty(data)) {
                for (const product in response.data[data].mandatory_products) {
                  if (
                    Object.prototype.hasOwnProperty.call(
                      response.data[data].mandatory_products,
                      product
                    )
                  ) {
                    response.data[data].mandatory_products[product][
                      "description"
                    ] = Utils.htmlToPlaintext(
                      response.data[data].mandatory_products[product]
                        .description
                    );
                  }
                  this.selectedProduct.push(
                    response.data[data].mandatory_products[product]["id"]
                  );
                }
              }
            }
            this.cartDetails = JSON.parse(this.cartsService.getCartItems());
            if (this.cartDetails.items && this.cartDetails.items.length) {
              this.cartDetails.items.forEach((cart) => {
                if (
                  cart.item_type == "grooming" &&
                  cart.mandatory_product_detail &&
                  cart.mandatory_product_detail.length &&
                  this.petDetail.id === cart.pet_id
                ) {
                  this.selectedProduct = cart.mandatory_product_detail.map(
                    (product) => product.id
                  );
                } else if (
                  cart.item_type == "grooming" &&
                  !(
                    cart.mandatory_product_detail &&
                    cart.mandatory_product_detail.length
                  )
                ) {
                  this.selectedProduct = [];
                }
              });
            }

            this.mandatoryProductList = response.data.filter(
              (data) => data.mandatory_products.length
            );

            this.isMandatoryProducts = this.mandatoryProductList.some(
              (data) => {
                if (data.mandatory_products.length > 0) {
                  return true;
                } else {
                  return false;
                }
              }
            );
          } else {
            return false;
          }
        },
        (error) => {
          return false;
        }
      );
  }
  selectvaccins(product) {
    if (this.selectedProduct.indexOf(product.id) == -1) {
      this.selectedProduct.push(product.id);
    } else {
      for (const key in this.selectedProduct) {
        if (this.selectedProduct.hasOwnProperty(key)) {
          if (this.selectedProduct[key] == product.id) {
            this.selectedProduct.splice(parseInt(key), 1);
          }
        }
      }
    }
  }
  getHolidayDateList() {
    this.http
      .post(
        API_URLS.LIST_OF_HOLIDAY_CALENDER,
        {
          out_post_id: localStorage.getItem("selectedOutpostId"),
          pet_type_id: this.selectedPetSpecies,
        },
        false
      )
      .subscribe(
        (res) => {
          this.holidayDateList = res.data;
        },
        (error) => {}
      );
  }

  checkDateForHoliday(date, type) {
    const convertDate = moment({
      year: date.year,
      month: date.month,
      day: date.day,
    }).format("YYYY-MM-DD");

    for (const holiday of this.holidayDateList) {
      if (type == "date") {
        for (const date of holiday.dates) {
          if (date == convertDate) {
            return true;
          }
        }
      } else if (type == "tooltip") {
        const isDatePresent = holiday.dates.includes(convertDate);
        if (isDatePresent) {
          return `Due to the ${
            holiday?.title
          } holiday rush, you will be charged additional ${this.cp.transform(
            holiday?.amount
          )} for the grooming service.`;
        }
      }
    }
  }

  // handle wizard next step click
  goToNext(tabValue) {
    if (this.active == "tab1") {
      this.validatePetSize = true;
      if (this.petSizeList.length > 0 && !this.selectedPetSize) {
        return false;
      } else {
        this.validatePetSize = false;
      }
    } else if (this.active == "tab4" && !this.groomingDate) {
      this.toastMessage("error", "Please select grooming date");
      return false;
    }

    if (this.active == "tab5" || this.active == "tab6") {
      this.getGroomingCalculation();
    }

    // Get the index of the active tab
    const currentIndex = this.getCurrentIndex(this.active, ""); // Extract the number from the active tab ID

    // If there's a next tab, select it
    if (currentIndex < 7) {
      const nextTabId = `tab${currentIndex + 1}`;
      this.active = nextTabId;

      // Change the color of the previous tab
      const previousTabId = `tab${currentIndex}`;

      const previousTabElement = document.getElementById(previousTabId);
      if (previousTabElement) {
        previousTabElement.querySelector("button").classList.add("completed"); // Change to desired color
      }

      const buttonElement = previousTabElement.querySelector("button");
      if (buttonElement) {
        // Check if the completed class is present
        const isCompleted = buttonElement.classList.contains("completed");
        // Set flag or mark as right based on the completed status
        if (isCompleted) {
          // Set flag or mark as right here
          if (previousTabId == "tab1") {
            this.isRightMarkForFirst = true;
          } else if (previousTabId == "tab2") {
            this.isRightMarkForSecond = true;
          } else if (previousTabId == "tab3") {
            this.isRightMarkForThird = true;
          } else if (previousTabId == "tab4") {
            this.isRightMarkForForth = true;
          } else if (previousTabId == "tab5") {
            this.isRightMarkForFifth = true;
          } else if (previousTabId == "tab6") {
            this.isRightMarkForSixth = true;
          }
        }
      }
    }
    if (this.activeTabs.includes(tabValue)) {
      this.activeTabs.splice(this.activeTabs.indexOf(tabValue), 1);
    }
  }

  goToPrev() {
    // Get the index of the active tab
    const currentIndex = this.getCurrentIndex(this.active, ""); // Extract the number from the active tab ID

    // If there's a previous tab, select it
    if (currentIndex > 1) {
      const previousTabId = `tab${currentIndex - 1}`;
      this.active = previousTabId;

      // Remove the completed class from the current tab button
      const currentTabId = `tab${currentIndex}`;

      const currentTabElement = document.getElementById(currentTabId);
      const prevTabElement = document.getElementById(previousTabId);

      const buttonElement = prevTabElement.querySelector("button");
      if (buttonElement) {
        // Check if the completed class is present
        const isCompleted = buttonElement.classList.contains("completed");
        // Set flag or mark as right based on the completed status
        if (isCompleted) {
          // Set flag or mark as right here
          if (previousTabId == "tab1") {
            this.isRightMarkForFirst = false;
          } else if (previousTabId == "tab2") {
            this.isRightMarkForSecond = false;
          } else if (previousTabId == "tab3") {
            this.isRightMarkForThird = false;
          } else if (previousTabId == "tab4") {
            this.isRightMarkForForth = false;
          } else if (previousTabId == "tab5") {
            this.isRightMarkForFifth = false;
          } else if (previousTabId == "tab6") {
            this.isRightMarkForSixth = false;
          }
        }
      }

      if (currentTabElement) {
        currentTabElement.querySelector("button").classList.remove("completed");
      }
    }
  }
  changeTab(event) {
    // Get the index of the newly selected tab
    const activeTabIndex = this.getCurrentIndex("", event);
    // Update the completed status of tabs
    this.updateTabCompletionStatus(activeTabIndex);
  }
  // Define a method to update the completed status of tabs
  updateTabCompletionStatus(activeTabIndex: number) {
    for (let i = 1; i <= 7; i++) {
      const tabId = `tab${i}`;
      const tabElement = document.getElementById(tabId);
      if (tabElement) {
        const buttonElement = tabElement.querySelector("button");
        if (buttonElement) {
          if (i < activeTabIndex) {
            buttonElement.classList.add("completed");
          } else {
            buttonElement.classList.remove("completed");
          }
        }
      }

      if (activeTabIndex == 1) {
        this.isRightMarkForFirst = false;
        this.isRightMarkForSecond = false;
        this.isRightMarkForThird = false;
        this.isRightMarkForForth = false;
        this.isRightMarkForFifth = false;
        this.isRightMarkForSixth = false;
      } else if (activeTabIndex == 2) {
        this.isRightMarkForFirst = true;
        this.isRightMarkForSecond = false;
        this.isRightMarkForThird = false;
        this.isRightMarkForForth = false;
        this.isRightMarkForFifth = false;
        this.isRightMarkForSixth = false;
      } else if (activeTabIndex == 3) {
        this.isRightMarkForFirst = true;
        this.isRightMarkForSecond = true;
        this.isRightMarkForThird = false;
        this.isRightMarkForForth = false;
        this.isRightMarkForFifth = false;
        this.isRightMarkForSixth = false;
      } else if (activeTabIndex == 4) {
        this.isRightMarkForFirst = true;
        this.isRightMarkForSecond = true;
        this.isRightMarkForThird = true;
        this.isRightMarkForForth = false;
        this.isRightMarkForFifth = false;
        this.isRightMarkForSixth = false;
      } else if (activeTabIndex == 5) {
        this.isRightMarkForFirst = true;
        this.isRightMarkForSecond = true;
        this.isRightMarkForThird = true;
        this.isRightMarkForForth = true;
        this.isRightMarkForFifth = false;
        this.isRightMarkForSixth = false;
      } else if (activeTabIndex == 6) {
        this.isRightMarkForFirst = true;
        this.isRightMarkForSecond = true;
        this.isRightMarkForThird = true;
        this.isRightMarkForForth = true;
        this.isRightMarkForFifth = true;
        this.isRightMarkForSixth = false;
      } else if (activeTabIndex == 7) {
        this.isRightMarkForFirst = true;
        this.isRightMarkForSecond = true;
        this.isRightMarkForThird = true;
        this.isRightMarkForForth = true;
        this.isRightMarkForFifth = true;
        this.isRightMarkForSixth = true;
      }
    }
  }
  openPreviousGroomerModal() {
    const modalRef = this.modalService.open(PreviousGroomerListComponent, {
      size: "xl",
      centered: true,
      backdrop: "static",
      keyboard: false,
      windowClass: "modal-bg-blue",
    });
    modalRef.componentInstance.fromParent = {
      previousGroomer: this.previousGroomer,
      previousGroomerAvailableDates: this.previousGroomerAvailableDates,
      valuesForCheckPlan: this.planDetail,
      selectedGroomingPlan: this.selectedGroomingPlan,
      selectedOutpostId: this.selectedOutpostId,
    };
    modalRef.componentInstance.continueGroomer.subscribe((res) => {
      if (res) {
        this.groomingDate = res.groomingDate;
        this.selectGroomingDate();
      }
    });
  }
  resetNavTab() {
    this.active = "tab1";
    this.updateTabCompletionStatus(1);
    this.activeTabs = [
      "plan",
      "addons",
      "date",
      "groomers",
      "products",
      "payment",
    ];
  }
}
